// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"3c1438d6","235":"ff8ddc02","787":"802a352c","836":"107dcfdf"}[chunkId] + ".chunk.js";
};